<ion-content [fullscreen]="true" class="background with-field"  id="insert-content">
  <ion-grid class="ion-margin-bottom" [ngSwitch]="type">

    <ion-row class="ion-margin-bottom">
      <ion-col class="ion-align-items-center ion-text-center" size="12">
        <app-ballot-creator *ngSwitchCase="'exchange'" [type]="'exchange'"></app-ballot-creator>
        <app-ballot-creator *ngSwitchCase="'formation'" [type]="'formation'"></app-ballot-creator>
        <app-ballot-creator *ngSwitchCase="'purchase'" [type]="'purchase'"></app-ballot-creator>
      </ion-col>
    </ion-row>

  </ion-grid>

  <div class="spacer-500"></div>

</ion-content>
